import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/components/view/HomeView.vue"),
  },
  {
    path: "/Intro",
    name: "intro",
    component: () => import("@/components/view/IntroView.vue"),
  },

  {
    path: "/service",
    name: "service",
    component: () => import("@/components/view/ServiceView.vue"),
  },
  {
    path: "/service/platform",
    name: "platform",
    component: () => import("@/components/view/ServiceView.vue"),
  },
  {
    path: "/way",
    name: "way",
    component: () => import("@/components/view/HomeView.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/components/view/NewsView.vue"),
  },
  {
    path: "/news/41",
    name: "newsdetail41",
    component: () => import("@/components/view/detail_news/news41.vue"),
  },
  {
    path: "/news/40",
    name: "newsdetail40",
    component: () => import("@/components/view/detail_news/news40.vue"),
  },
  {
    path: "/news/39",
    name: "newsdetail39",
    component: () => import("@/components/view/detail_news/news39.vue"),
  },
  {
    path: "/news/38",
    name: "newsdetail38",
    component: () => import("@/components/view/detail_news/news38.vue"),
  },
  {
    path: "/news/37",
    name: "newsdetail37",
    component: () => import("@/components/view/detail_news/news37.vue"),
  },
  {
    path: "/news/36",
    name: "newsdetail36",
    component: () => import("@/components/view/detail_news/news36.vue"),
  },
  {
    path: "/news/35",
    name: "newsdetail35",
    component: () => import("@/components/view/detail_news/news35.vue"),
  },
  {
    path: "/news/34",
    name: "newsdetail34",
    component: () => import("@/components/view/detail_news/news34.vue"),
  },
  {
    path: "/news/33",
    name: "newsdetail33",
    component: () => import("@/components/view/detail_news/news33.vue"),
  },
  {
    path: "/news/32",
    name: "newsdetail32",
    component: () => import("@/components/view/detail_news/news32.vue"),
  },
  {
    path: "/news/31",
    name: "newsdetail31",
    component: () => import("@/components/view/detail_news/news31.vue"),
  },
  {
    path: "/news/30",
    name: "newsdetail30",
    component: () => import("@/components/view/detail_news/news30.vue"),
  },
  {
    path: "/news/29",
    name: "newsdetail29",
    component: () => import("@/components/view/detail_news/news29.vue"),
  },
  {
    path: "/news/28",
    name: "newsdetail28",
    component: () => import("@/components/view/detail_news/news28.vue"),
  },
  {
    path: "/news/27",
    name: "newsdetail27",
    component: () => import("@/components/view/detail_news/news27.vue"),
  },
  {
    path: "/news/26",
    name: "newsdetail26",
    component: () => import("@/components/view/detail_news/news26.vue"),
  },
  {
    path: "/news/25",
    name: "newsdetail25",
    component: () => import("@/components/view/detail_news/news25.vue"),
  },
  {
    path: "/news/24",
    name: "newsdetail24",
    component: () => import("@/components/view/detail_news/news24.vue"),
  },
  {
    path: "/news/23",
    name: "newsdetail23",
    component: () => import("@/components/view/detail_news/news23.vue"),
  },
  {
    path: "/news/22",
    name: "newsdetail22",
    component: () => import("@/components/view/detail_news/news22.vue"),
  },
  {
    path: "/news/21",
    name: "newsdetail21",
    component: () => import("@/components/view/detail_news/news21.vue"),
  },
  {
    path: "/news/20",
    name: "newsdetail20",
    component: () => import("@/components/view/detail_news/news20.vue"),
  },
  {
    path: "/news/19",
    name: "newsdetail19",
    component: () => import("@/components/view/detail_news/news19.vue"),
  },
  {
    path: "/news/18",
    name: "newsdetail18",
    component: () => import("@/components/view/detail_news/news18.vue"),
  },
  {
    path: "/news/17",
    name: "newsdetail17",
    component: () => import("@/components/view/detail_news/news17.vue"),
  },
  {
    path: "/news/16",
    name: "newsdetail16",
    component: () => import("@/components/view/detail_news/news16.vue"),
  },
  {
    path: "/news/15",
    name: "newsdetail15",
    component: () => import("@/components/view/detail_news/news15.vue"),
  },
  {
    path: "/news/14",
    name: "newsdetail14",
    component: () => import("@/components/view/detail_news/news14.vue"),
  },
  {
    path: "/news/13",
    name: "newsdetail13",
    component: () => import("@/components/view/detail_news/news13.vue"),
  },
  {
    path: "/news/12",
    name: "newsdetail12",
    component: () => import("@/components/view/detail_news/news12.vue"),
  },
  {
    path: "/news/11",
    name: "newsdetail11",
    component: () => import("@/components/view/detail_news/news11.vue"),
  },
  {
    path: "/news/10",
    name: "newsdetail10",
    component: () => import("@/components/view/detail_news/news10.vue"),
  },
  {
    path: "/news/9",
    name: "newsdetail9",
    component: () => import("@/components/view/detail_news/news9.vue"),
  },
  {
    path: "/news/8",
    name: "newsdetail8",
    component: () => import("@/components/view/detail_news/news8.vue"),
  },
  {
    path: "/news/7",
    name: "newsdetail7",
    component: () => import("@/components/view/detail_news/news7.vue"),
  },
  {
    path: "/news/6",
    name: "newsdetail6",
    component: () => import("@/components/view/detail_news/news6.vue"),
  },
  {
    path: "/news/5",
    name: "newsdetail5",
    component: () => import("@/components/view/detail_news/news5.vue"),
  },
  {
    path: "/news/4",
    name: "newsdetail4",
    component: () => import("@/components/view/detail_news/news4.vue"),
  },
  {
    path: "/news/3",
    name: "newsdetail3",
    component: () => import("@/components/view/detail_news/news3.vue"),
  },
  {
    path: "/news/2",
    name: "newsdetail2",
    component: () => import("@/components/view/detail_news/news2.vue"),
  },
  {
    path: "/news/1",
    name: "newsdetail1",
    component: () => import("@/components/view/detail_news/news1.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/components/view/ContactView.vue"),
  },
  {
    path: "/employ",
    name: "employ",
    component: () => import("@/components/view/EmployView.vue"),
  },
  {
    path: "/header",
    name: "Header",
    component: () => import("@/components/header/HeaderNav.vue"),
  },
  {
    path: "/menu",
    name: "menu",
    component: () => import("@/components/header/Menu.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/components/view/test.vue"),
  },

  {
    path: "/footer",
    name: "Footer",
    component: () => import("@/components/footer/Footer.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to) {
    if (to.path === "/way") {
      return { top: document.body.scrollHeight };
    }
    if (to.path === "/service/platform") {
      const service = document.querySelector("section");
      return { top: service.scrollHeight };
    } else {
      return { top: 0 };
    }
  },
});

export default router;
